import {
  currencies,
  EXCLUDED_CURRENCY_CODES,
  HARD_404_CURRENCY_CODES,
} from 'constants/currency';

export const filterByWhiteList = (data, activeKey) => {
  const keys = activeKey ? [activeKey] : Object.values(currencies);
  const whiteList = new Map(keys.map(item => [item, item]));

  return data
    .filter(el => whiteList.has(el?.code?.toLowerCase()))
    .sort((a, b) => a.iso - b.iso);
};
export const filterByCurrency = (data, activeKey) => {
  if (data && activeKey) {
    return data.filter(el => {
      return el.currency === activeKey;
    });
  }

  return data;
};

export const filterRatesByCurrency = (data, activeKey) => {
  if (!data) {
    return [];
  }

  if (
    activeKey &&
    Object.prototype.hasOwnProperty.call(data, activeKey.toUpperCase())
  ) {
    return [data[activeKey.toUpperCase()]];
  }

  return Object.values(data).sort((a, b) => a.sort - b.sort);
};

export const filterExcludedCurrencies = list => {
  if (!Array.isArray(list)) {
    return list;
  }

  return list.filter(item => {
    const code =
      item?.code?.toLowerCase() ||
      item?.id?.toLowerCase() ||
      item?.slug?.toLowerCase() ||
      '';
    return code && !EXCLUDED_CURRENCY_CODES.includes(code);
  });
};

export const filterHard404Currencies = list => {
  if (!Array.isArray(list)) {
    return list;
  }

  return list.filter(item => {
    const code =
      item?.code?.toLowerCase() ||
      item?.id?.toLowerCase() ||
      item?.slug?.toLowerCase() ||
      '';
    return code && !HARD_404_CURRENCY_CODES.includes(code);
  });
};

export const filterExcludedLinks = links => {
  if (!Array.isArray(links)) {
    return links;
  }

  return links.filter(link => {
    const urlLower = (link.url || '').toLowerCase();
    const hasExcludedCurrency = EXCLUDED_CURRENCY_CODES.some(
      code => urlLower.includes(`/${code}-`) || urlLower.includes(`-${code}/`)
    );

    return !hasExcludedCurrency;
  });
};

export default filterByWhiteList;
